module.exports = __webpack_public_path__ + "img/pudge.f350196c.jpg";